import AIModelService from '../service/aiModel';
const state = {
    query: {
        customer: "",
        point: "",
        page: 1,
        pageSize: 10,
    },
    loading: false,
    searchResult: {
        total: 0,
        models: [],
    },
    modelDetail: "",
    predictLoading: false,
};

const actions = {
    createAIModel({ commit }, aiModel) {
        return AIModelService.createAIModel(aiModel).then(data => {
            aiModel._id = data._id;
            commit('addAIModel', aiModel);
            return data;
        });
    },
    saveModelClasses(_,{modelId,classes}){
        return AIModelService.saveModelClasses(modelId, classes).then(data => {
            return data;
        })
    },
    predict({ dispatch, commit }, {modelId, measurementId}) {
        commit('setPredictLoading', true);
        return AIModelService.predict(modelId, measurementId).then(data => {
            dispatch('getAIModel', modelId);

            return data;
        }).finally(() => {
            commit('setPredictLoading', false);
        });
    },
    deleteAIModel({ commit }, id) {
        return AIModelService.deleteAIModel(id).then(() => {
            commit('removeAIModel', id);
            return id;
        });
    },
    getAIModel({ commit }, modelId) {
        commit('setLoading', true);
        return AIModelService.getAIModel(modelId).then(res => {
            commit('setModelDetail', res);
        }).catch(() => {
            commit('setLoading', false);
        });
    },
    updateAIModelPublishStatus({ commit }, { modelId, published }) {
        return AIModelService.updateAIModelPublishStatus(modelId, published).then(() => {
            commit('setModelDetailPublishStatus', { published });
        });
    },
    getAIModels({ commit }, query) {
        commit('setLoading', true);
        return AIModelService.getAIModels(query).then(res => {
            commit('setAIModels', res);
        }).catch(() => {
            commit('setLoading', false);
        });
    },

};
const mutations = {
    addAIModel(state, aiModel) {
        state.searchResult.aiModels.push(aiModel);
    },
    removeAIModel(state, id) {
        var index = state.searchResult.aiModels.findIndex(x => x._id == id);
        if (index) {
            state.searchResult.aiModels.splice(index, 1);
        }
    },
    setModelDetailPublishStatus(state, { published }) {
        state.modelDetail.published =published;
    },
    setPredictLoading(state, b) {
        state.predictLoading = b;
    },
    setModelDetail(state, model) {
        state.modelDetail = model;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setAIModels(state, models) {
        state.searchResult = models;
        state.loading = false;
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};



